export default {
  mfaInfo: 'MFA information',
  totp: 'MFA device',
  mobile: 'Secure phone',
  email: 'Secure email',
  phoneNumber: 'Phone number',
  emailAddress: 'Email address',
  bind: 'Bind',
  unbind: 'Unbind',
  unbound: 'Unbound',
  areYouSureYouWantToUnbind_name: 'Are you sure you want to unbind {name}?',
  pleaseEnterYourPasswordToUnbind: 'Please enter your password to unbind',
  pleaseEnterThePassword: 'Please enter the password',
  passwordCannotBeEmpty: 'Password cannot be empty',
  name_unbindingSuccessful: '{name} unbinding successful',
  name_bindingSuccessful: '{name} binding successful',
  totpDeviceHasBeenBound: 'TOTP device has been bound',
  bindSecurityMobile: 'Bind Security Mobile',
  bindSecurityEmail: 'Bind Security Email',
  bindVirtualMfa: 'Bind Virtual MFA',
  selectMfaTypeToBind: 'Select MFA type to bind',
  bindMobileTips: 'After binding your security mobile, two-factor authentication will be required for login and risky operations to block suspicious behavior and protect your account.',
  bindEmailTips: 'After binding your security email, two-factor authentication will be required for login and risky operations to block suspicious behavior and protect your account.',
  bindVirtualMfaTips1: '1.Use a virtual MFA app to scan the QR code or manually enter the secret key. If the app already has a device with the same name, delete it before rebinding.',
  bindVirtualMfaTips2: '2.Enter the 6-digit security code displayed in the MFA app.',
  selectMfaTypeToBindTips1: 'According to your account settings, you need to enable an MFA device to complete login',
  selectMfaTypeToBindTips2: 'Click an option to select a different MFA device for binding.',
  pleaseEnterThePhonenumber: 'Please enter the phone number',
  pleaseEnterTheEmail: 'Please enter the email',
  pleaseEnterTheCode: 'Please enter the code',
  phoneNumberCannotBeEmpty: 'Phone number cannot be empty',
  emailCannotBeEmpty: 'Email cannot be empty',
  pleaseEnterTheCorrectFormat: 'Please enter the correct format',
  codeCannotBeEmpty: 'Code cannot be empty',
  pleaseEnterThe_6DigitCode: 'Please enter the 6-digit code',
  codeHasBeenSentTo_emailOrPhone: 'The code has been sent to {emailOrPhone}.',
  count_Resend: '{count}s Resend',
  getCode: 'Get Code',
  copySecretKey: 'Copy Secret Key',
  pleaseEnterThe_6DigitSecurityCode: 'Please enter the 6-digit security code',
  securityCodeCannotBeEmpty: 'Security code cannot be empty',
  confirm: 'Confirm',
  cancel: 'Cancel',
  copySuccessful: 'Copied successfully',
  copyFailed: 'Copy failed',
  theSecretKeyDoesNotExist: 'The secret key does not exist',
  bindOtherMfaTypes: 'Bind other MFA types',
  bindEmailViaEmailVerificationCode: 'Bind your email by receiving a verification code via email.',
  bindMobileViaSmsVerificationCode: 'Bind your mobile number with a verification code via SMS.',
  bindByScanningWithMobileMfaApp: 'Bind by scanning the QR code with the MFA verification app on your mobile phone.',
  submitVerification: 'Submit Verification',
  username: 'Username',
  securityCode: 'Security Code',
  captcha: 'Captcha',
  loginVerificationPrompt: 'To ensure that the operations on account {account} are performed by you, please select any method to verify your identity.',
  verificationSuccessful: 'Verification successful',
  verificationFreeLogin: '30-Day Verification-Free Login'
}
